import { Show, createEffect, createSignal, onMount } from "solid-js";
import Ammo from "ammojs-typed";
import GameObject from "@objects/game";
import { dead, loaded, overlay, paused } from "@stores";
import ThemeController from "@controllers/theme";
import AssetLoader from "@managers/loaders";
import Loading from "@gui/views/loading";
import InformationOverlay from "@gui/views/info";
import GraphicalUserInterface from "@gui/views/gui";
import DeathScreen from "@gui/views/death";
import PauseScreen from "@gui/views/pause";
import ErrorScreen from "@gui/views/error";
const App = () => {
    const [error, setError] = createSignal();
    /**
     * Initialize the application.
     * Run an instance of the game upon Ammo.js Promise resolution.
     */
    const initialize = () => {
        ThemeController.init();
        AssetLoader.getInstance();
    };
    const isLoaded = () => {
        if (!loaded() || error())
            return false;
        return loaded().amountOfAssetsToLoad === loaded().amountOfAssetsLoaded;
    };
    const run = () => {
        if (!isLoaded())
            return;
        Ammo(Ammo)
            .then(() => {
            try {
                GameObject.getInstance().run();
            }
            catch (error) {
                console.error(error);
                setError(error);
            }
        })
            .catch(err => console.error(err));
    };
    createEffect(run);
    onMount(initialize);
    return (<Show when={isLoaded()} fallback={<Loading />}>
            <Show when={!error()} fallback={<ErrorScreen error={error()}/>}>
                <GraphicalUserInterface />
                <Show when={overlay()}>
                    <InformationOverlay />
                </Show>
                <Show when={paused() && !dead()}>
                    <PauseScreen />
                </Show>
                <Show when={dead()}>
                    <DeathScreen />
                </Show>
            </Show>
        </Show>);
};
export default App;
